import React from 'react';
import { IconX } from '@tabler/icons-react';

const DiscordPreviewModal = ({ campaign, onClose }) => {
 if (!campaign) return null;

 const perCreatorPayment = campaign.requiredCreators > 0
 ? Math.round(campaign.budget / campaign.requiredCreators)
 : 0;

 return (
 <div
 className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
 onClick={onClose}
 >
 <div
 className="ui-motion-modal max-w-2xl w-full mx-4"
 style={{ backgroundColor: '#2f3136' }}
 onClick={(e) => e.stopPropagation()}
 >
 <div className="flex justify-between items-center p-4" style={{ borderBottom: '1px solid #40444b' }}>
 <h2 className="text-lg font-bold text-white">Discord Message Preview</h2>
 <button onClick={onClose} className="text-gray-400 hover:text-white">
 <IconX size={22} />
 </button>
 </div>

 <div className="p-6" style={{ backgroundColor: '#36393f' }}>
 <div className="flex gap-3">
 <div
 className="w-10 h-10 flex-shrink-0 flex items-center justify-center text-white font-bold text-sm"
 style={{ backgroundColor: '#5865F2' }}
 >
 B
 </div>

 <div className="flex-1">
 <div className="flex items-center gap-2 mb-2">
 <span className="text-white font-semibold text-sm">Bricktopian Bot</span>
 <span
 className="px-1.5 py-0.5 text-[10px] text-white font-medium"
 style={{ backgroundColor: '#5865F2' }}
 >
 BOT
 </span>
 <span className="text-gray-500 text-xs">Today at 12:00 PM</span>
 </div>

 <div
 className="p-4 "
 style={{
 backgroundColor: '#2f313699',
 borderLeft: '4px solid var(--accent)'
 }}
 >
 <div className="text-base font-bold text-white mb-2">
 {campaign.name}
 </div>
 <div className="text-gray-300 text-sm mb-3 whitespace-pre-wrap">
 {campaign.amplificationConfig?.announcement?.messageText ||
 campaign.briefingMessage?.content ||
 `We're launching a new amplification campaign! React with ✅ to join.`}
 </div>
 <div className="grid grid-cols-2 gap-2 text-sm">
 <div>
 <span className="text-gray-400">Creators Needed:</span>
 <span className="text-white ml-2">{campaign.requiredCreators}</span>
 </div>
 <div>
 <span className="text-gray-400">Payment:</span>
 <span className="text-white ml-2">${perCreatorPayment}</span>
 </div>
 <div>
 <span className="text-gray-400">Type:</span>
 <span className="text-white ml-2">{campaign.pricingType}</span>
 </div>
 <div>
 <span className="text-gray-400">Deadline:</span>
 <span className="text-white ml-2">
 {campaign.endDate ? new Date(campaign.endDate).toLocaleDateString() : 'TBD'}
 </span>
 </div>
 </div>
 </div>

 <div className="mt-3 flex items-center gap-2 text-gray-500 text-sm">
 <span>{campaign.amplificationConfig?.announcement?.targetEmoji || '✅'}</span>
 <span>
 {campaign.amplificationConfig?.announcement?.isActive
 ? 'Active - collecting reactions'
 : 'Announcement posted'}
 </span>
 </div>
 </div>
 </div>
 </div>

 <div className="p-4 text-center" style={{ backgroundColor: '#2f3136', borderTop: '1px solid #40444b' }}>
 <button
 onClick={onClose}
 className="px-6 py-2 text-white text-sm"
 style={{ backgroundColor: '#4f545c' }}
 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#5d6269'}
 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#4f545c'}
 >
 Close
 </button>
 </div>
 </div>
 </div>
 );
};

export default DiscordPreviewModal;
